<template>
  <div class="h-screen">
    <div class="flex flex-col h-full w-full text-red-500 bg-yellow-500">
      <div class="flex container mx-auto mt-32 text-left">
        <div class="inline mx-auto">
          <h1 class="text-5xl mb-8 font-bold">CONTACT</h1>

          <div class="mb-8 text-2xl">
            <p class="underline"><a target="_blank" href="http://privority.com/">Privority GmbH</a></p>
            <p>Friedrichstr. 95</p>
            <p>D-10117 Berlin</p>
            <p>Germany</p>
          </div>

          <div class="text-2xl mb-10">
            <p><a href="mailto:contact@privority.com">E: contact@privority.com</a></p>
            <p>T: (+49) 30 206 198 30</p>
          </div>
        </div>
      </div>
    </div>

    <Navigation textColor="black"/>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";

export default {
  name: "Contact",
  components:{
    Navigation
  },
}
</script>

<style lang="css" scoped>
</style>
